"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var menuItemBlacklist = ['logout', 'account', 'home'];
var menuEndpoint = function menuEndpoint(client) {
  var get = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var menu;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return client.restClient.withVersion(2, /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(v2Client) {
                var _yield$v2Client$get, data;
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return v2Client.get('');
                    case 2:
                      _yield$v2Client$get = _context.sent;
                      data = _yield$v2Client$get.data;
                      return _context.abrupt("return", (data === null || data === void 0 ? void 0 : data.menu) || []);
                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }());
          case 2:
            menu = _context2.sent;
            return _context2.abrupt("return", menu);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function get() {
      return _ref.apply(this, arguments);
    };
  }();
  var items = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var allItems, itemsFiltered, accountItem, logoutItem, homeItem;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return get();
          case 2:
            allItems = _context3.sent;
            if (allItems.items) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return", {
              items: [],
              accountItem: undefined,
              homeItem: undefined
            });
          case 5:
            itemsFiltered = allItems.items.filter(function (item) {
              return !menuItemBlacklist.includes(item.slug);
            });
            accountItem = allItems.items.find(function (item) {
              return item.slug === 'account';
            });
            logoutItem = allItems.items.find(function (item) {
              return item.slug === 'logout';
            });
            homeItem = allItems.items.find(function (item) {
              return item.slug === 'home';
            });
            if (accountItem) {
              if (!accountItem.subItems) {
                accountItem.subItems = [logoutItem];
              } else {
                accountItem.subItems.push(logoutItem);
              }
            }
            return _context3.abrupt("return", {
              items: itemsFiltered,
              accountItem: accountItem,
              homeItem: homeItem
            });
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function items() {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    get: get,
    items: items
  };
};
var _default = menuEndpoint;
exports.default = _default;